import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'post'

export default class OspreyTemplatesPreview extends BaseAction {
    constructor(dataKey, onError) {
        const id = '48135cab-2415-4298-b7d7-e40a85737423'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    preview(params, id) {
        
        this.path = id ? `/${resource}/${id.value}/preview` : `/${resource}/preview`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-preview.js